import api from './api';

export const getConsultantContactsApi = (params) => api().get('/consultants-contacts', { params });
export const addNewConsultantContactApi = (data) => api().post('/consultants-contacts', data);
export const deleteConsultantContactsApi = (params) => api().delete('/consultants-contacts', { params });
export const updateConsultantContactsApi = (params) => api().put(`/consultants-contacts/${params.id}`, params.values);
